import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/services-bg.mp4")